import { EvtHeader } from "components/header";
import React from "react";
import CurrencyForm from "../form";

const CreateCurrency = () => {
  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Create Currency" />
      <div className="p-6 max-w-2xl">
        <CurrencyForm />
      </div>
    </div>
  );
};

export default CreateCurrency;
